import ENDPOINTS from "@app/constants/endpoints"
import { fetchWithValidation } from "@app/helpers/fetchWithValidation"
import { useQuery } from "@tanstack/react-query"
import { type User, UserSchema } from "../models/user"

export const useUser = () => {
  return useQuery<User, Error>({
    queryKey: ["user"],
    queryFn: () => fetchWithValidation(ENDPOINTS.USER, UserSchema),
    staleTime: 1000 * 60 * 10, // 10 minutes - data is fresh for 10 min
    gcTime: 1000 * 60 * 60 * 24, // 24 hours - keep in cache for 24 hours
    retry: 1, // Only retry once on auth failure
    refetchOnMount: false, // Don't refetch if data is fresh
    refetchOnWindowFocus: true, // Revalidate when user returns to tab
    refetchOnReconnect: true, // Revalidate when connection restored
  })
}
